export const CLIENT_NAMES = {
  ECR: 'ECR',
  GOCAR: 'GOCAR'
}